import { apiServiceProxy } from '../api-proxy';

class CustomerService {
  public async loadCustomerByEmail(email: string) {
    try {
      const result = await apiServiceProxy.get<{ id: number; business_name: string; name: string }[]>(
        '/customers?email={email}'.replace('{email}', encodeURIComponent(email))
      );
      return result.data;
    } catch (error) {
      return [];
    }
  }
}

const customerService = new CustomerService();

export default customerService;
